import Http from './../http';

const prefix = '/turbo';

export const storePage = (params) => {
  return Http.authApi().post(`${prefix}/storePage`, params);
};

export const updatePage = (page_id, params) => {
  return Http.authApi().put(`${prefix}/updatePage/${page_id}`, params);
};

export const getPage = (page_id) => {
  return Http.authApi().get(`${prefix}/getPage/${page_id}`);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/turbo.js